import { render } from "./BtnGroupXMobile.vue?vue&type=template&id=de4d3f60&scoped=true"
import script from "./BtnGroupXMobile.vue?vue&type=script&lang=js"
export * from "./BtnGroupXMobile.vue?vue&type=script&lang=js"

import "./BtnGroupXMobile.vue?vue&type=style&index=0&id=de4d3f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4d3f60"]])

export default __exports__